<template>
  <div>
    <bs-card class="card-info">
      <bs-table v-bind="{dataLength, loading}" :cols="4">
        <template v-slot:thead>
          <tr>
            <bs-th :label="$t('labels.name')" :sortable="resourceState.sort" :col="'name'" @click="applySort"></bs-th>
            <bs-th :label="$t('labels.registration')" :sortable="resourceState.sort" :col="'registration'" @click="applySort"></bs-th>
            <bs-th :label="$t('labels.driver')"></bs-th>
            <bs-th></bs-th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td class="clickable" @click="$router.push({ path: '/vehicle/' + r.id })">{{ r.name }}</td>
          <td class="clickable" @click="$router.push({ path: '/vehicle/' + r.id })">{{ r.registration }}</td>
          <td class="clickable" @click="$router.push({ path: '/vehicle/' + r.id })">{{ r.driver }}</td>
          <td class="t2">
            <bs-action v-if="auth.can['edit_customers']" :icon="['fal', 'pencil']" :tip="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.edit') })" class="btn-info" @click="update(r)"></bs-action>
            <bs-action v-if="auth.can['edit_customers']" :icon="['fal', 'trash']" :tip="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.destroy') })" class="btn-danger" @click="destroy(r)"></bs-action>
          </td>
        </tr>
      </bs-table>
    </bs-card>
    <bs-modal :name="'create-' + $options.name" :label="$t('labels.action_' + camelToSnake(singular($options.name)), { action: resource.id ? $t('labels.edit') : $t('labels.create') })">
      <bs-form :submit="$t('labels.submit')" @submit="submit">
        <template v-slot:default="slotProps">
          <tuxedo-input :name="'name'" :label="$t('labels.description')" :help="$t('tips.vehicle_description')" v-model="resource.name" :error="slotProps.error" />
          <tuxedo-input :name="'registration'" :label="$t('labels.registration')" :help="$t('tips.vehicle_registration')" v-model="resource.registration" :error="slotProps.error" />
          <tuxedo-input :name="'imei'" :label="$t('labels.imei')" v-model="resource.imei" :error="slotProps.error" />
          <tuxedo-select :name="'default_driver'" :label="$t('labels.default_driver')" v-model="resource.default_driver" :options="orderedUsers" :insistReturn="'id'" :insistLabel="'name'" :help="$t('tips.default_driver')" :error="slotProps.error" />
        </template>
      </bs-form>
    </bs-modal>
    <bs-modal :name="'destroy-' + $options.name" :label="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.destroy') })">
      <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
        {{ $t('messages.delete', { resource: $t('labels.customer') }) }}
      </bs-form>
    </bs-modal>
    <portal to="app-footer">
      <pagination :data="resources" :state="resourceState" @pushPage="index"></pagination>
    </portal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'debounce'

export default {
  name: 'Vehicles',
  data () {
    return {
      loading: false,
      activeId: null,
      resource: {
        name: '',
        registration: '',
        imei: ''
      }
    }
  },
  mounted () {
    this.search = debounce(this.search, 500)
    this.index(this.resourceState.page)
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      users: state => state.usersStore,
      resources: state => state.vehicles,
      submitting: state => state.submitting,
      resourceState: state => state.vehiclesState
    }),
    dataLength () {
      let length = 0
      if (this.resources.data) length = this.resources.data.length
      return Math.max(this.resourceState.tableRows - length, 0)
    },
    orderedUsers () {
      return this._.orderBy(this.users, ['name'])
    },
    searchPhrase: {
      get () {
        return this.resourceState.search.phrase
      },
      set (val) {
        this.applySearch({ active: true, phrase: val })
      }
    }

  },
  methods: {
    applySearch (val) {
      this.$store.commit('pushState', { view: this.$options.name, key: 'search', data: val })
      this.search()
    },
    search () { this.index(1) },
    applySort (val) {
      this.$store.commit('pushState', { view: this.$options.name, key: 'sort', data: val })
      this.index()
    },
    index (page, count) {
      if (page) this.$store.commit('pushState', { view: this.$options.name, key: 'page', data: page })
      if (count) this.$store.commit('pushState', { view: this.$options.name, key: 'tableRows', data: count })
      this.loading = true
      this.$store.dispatch('index', {
        collection: this.$options.name,
        data: {
          icon: ['fal', 'truck-pickup']
        }
      }).then(() => {
        this.loading = false
      })
    },
    create () {
      this.$root.clearData(this.resource)
      this.$modal.show('create-' + this.$options.name)
    },
    destroy (o) {
      this.activeId = o.id
      this.$modal.show('destroy-' + this.$options.name)
    },
    update (o) {
      this.resource = JSON.parse(JSON.stringify(o))
      this.$modal.show('create-' + this.$options.name)
    },
    submit () {
      this.$store.dispatch(this.resource.id ? 'update' : 'store', { collection: this.$options.name, resource: this.resource }).then(() => {
        this.$modal.hide('create-' + this.$options.name)
      })
    },
    destruction () {
      this.$store.dispatch('destroy', { collection: this.$options.name, id: this.activeId }).then(() => {
        this.$modal.hide('destroy-' + this.$options.name)
      })
    }
  }
}
</script>
